import { render, staticRenderFns } from "./maintenance.vue?vue&type=template&id=523155c2&scoped=true"
import script from "./maintenance.vue?vue&type=script&lang=js"
export * from "./maintenance.vue?vue&type=script&lang=js"
import style0 from "./maintenance.vue?vue&type=style&index=0&id=523155c2&prod&lang=css"
import style1 from "./maintenance.vue?vue&type=style&index=1&id=523155c2&prod&lang=scss&scoped=true"
import style2 from "./maintenance.vue?vue&type=style&index=2&id=523155c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523155c2",
  null
  
)

export default component.exports